import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculationService } from './calculation.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-calculation',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <button mat-button (click)="onStartCalculation()">Start Calculation</button>
    <button mat-button class="ml-4" (click)="onCancelCalculation()">Cancel Calculation</button>
  `,
  providers: [CalculationService]
})
export class CalculationComponent {
  constructor(private calculationService: CalculationService) {}

  onStartCalculation() {
    this.calculationService.startCalculation().subscribe({
      next: data => console.log('Calculation result:', data.result),
      error: error => console.error('Error during calculation:', error),
      complete: () => console.log('Calculation completed')
    });
  }

  onCancelCalculation() {
    this.calculationService.cancelCalculation()?.subscribe({
      next: () => console.log('Calculation operation canceled'),
      error: error => console.error('Error canceling calculation:', error)
    });
  }
}
